import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div className="wrapper notfound">
                <p>PAGE DOES NOT EXIST.</p>
            </div>
        )
    }
}

export default NotFound;
